/**
 * useTokenSync Hook
 *
 * Watches the auth store and syncs the access token to the API client.
 * This keeps the API client's auth token in sync with the Supabase session.
 */

import { useEffect } from 'react'
import { useAuthStore } from '@restaurant/core'
import { apiClient } from '@restaurant/api-client'
import { isShowcase } from '../showcase/showcase'

export function useTokenSync() {
  const token = useAuthStore((state) => state.token)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  useEffect(() => {
    if (isShowcase()) return
    if (isAuthenticated && token?.accessToken) {
      // Sync token to API client for Flask API requests
      apiClient.setToken(token.accessToken)
    } else {
      // Clear token when logged out
      apiClient.clearToken()
    }
  }, [isAuthenticated, token])
}
